import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBtComponent } from './simple-icons-bt.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBtComponent ],
    exports:      [ SimpleIconsBtComponent ],
    bootstrap:    []
})
export class SimpleIconsBtModule {}
